import { useEffect, useState } from "react";
import { CornerDownRight, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSwitchCave } from "@/components/SubCellars";

const eur = (v) => `€${Math.round(v).toLocaleString("pt-PT")}`;
const COLS = [["bottles", "Bottles"], ["pending", "Pending"], ["wines", "Wines"], ["boxes", "Boxes"], ["consumed", "Consumed"], ["sold", "Sold"]];

const Cells = ({ r, testid }) => (
  <>
    {COLS.map(([k]) => <td key={k} className="px-3 py-3 text-right font-mono text-[#F5F0EB]" data-testid={`${testid}-${k}`}>{r[k]}</td>)}
    <td className="px-3 py-3 text-right font-mono text-[#F5F0EB]" data-testid={`${testid}-value`}>{eur(r.value)}{r.unpriced ? <span className="block text-[10px] text-[#6E665D]">{r.unpriced} without price</span> : null}</td>
    <td className="px-3 py-3 text-right font-mono text-[#D4AF37]" data-testid={`${testid}-sale-value`}>{eur(r.sale_value)}</td>
  </>
);

export const ClientSummary = () => {
  const { user } = useAuth();
  const go = useSwitchCave();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/caves/family/summary").then((r) => setData(r.data)).catch(() => setData(null));
  }, [user.cave_id]);
  if (!data || data.cellars.length < 2 || data.root.id !== user.cave_id) return null;
  return (
    <section className="mb-10" data-testid="client-summary">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-2">Client summary</p>
      <h3 className="font-serif text-2xl text-[#F5F0EB] mb-4">{data.root.name} · all {data.cellars.length} cellars</h3>
      <div className="rounded-xl border border-[#2E252A] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#110D0F] font-mono text-[10px] uppercase tracking-[0.2em] text-[#6E665D]">
            <tr>
              <th className="px-4 py-3 text-left font-normal">Cellar</th>
              {COLS.map(([k, l]) => <th key={k} className="px-3 py-3 text-right font-normal">{l}</th>)}
              <th className="px-3 py-3 text-right font-normal">Purchase value</th>
              <th className="px-3 py-3 text-right font-normal">Est. sale value</th>
            </tr>
          </thead>
          <tbody>
            {data.cellars.map((r) => (
              <tr key={r.id} onClick={() => go(r)} className="border-t border-[#2E252A] cursor-pointer hover:bg-[#1E181B] group" data-testid={`client-summary-row-${r.id}`}>
                <td className="px-4 py-3 text-[#F5F0EB]">
                  <span className="flex items-center gap-2">{r.parent_id ? <CornerDownRight className="w-3.5 h-3.5 text-[#6E665D]" /> : null}{r.parent_id ? r.name : `${r.name} (main)`}
                    {r.parent_id && <ArrowRight className="w-3.5 h-3.5 text-[#6E665D] opacity-0 group-hover:opacity-100 transition-opacity" />}</span>
                </td>
                <Cells r={r} testid={`client-summary-${r.id}`} />
              </tr>
            ))}
            <tr className="border-t-2 border-[#D4AF37]/40 bg-[#110D0F]" data-testid="client-summary-total">
              <td className="px-4 py-3 font-mono text-xs uppercase tracking-widest text-[#D4AF37]">Total</td>
              <Cells r={data.total} testid="client-summary-total" />
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-xs text-[#6E665D] mt-2">Purchase value uses each bottle's purchase price; estimated sale value uses the wine's average selling price. Click a cellar to open it.</p>
    </section>
  );
};
